import { render, staticRenderFns } from "./DocsSetting.vue?vue&type=template&id=91737512&scoped=true"
import script from "./DocsSetting.vue?vue&type=script&lang=js"
export * from "./DocsSetting.vue?vue&type=script&lang=js"
import style0 from "./DocsSetting.vue?vue&type=style&index=0&id=91737512&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91737512",
  null
  
)

export default component.exports